import { createContext, useState, useEffect } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const GRNContext = createContext();

export const GRNProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    const auth = localStorage.getItem('isAuthenticated');
    return auth === 'true';
  });

  const [user, setUser] = useState(() => {
    try {
      const storedUser = localStorage.getItem("user");
      if (!storedUser || storedUser === "undefined" || storedUser === "") {
        localStorage.removeItem("user");
        localStorage.removeItem("isAuthenticated");
        return null;
      }
      return JSON.parse(storedUser);
    } catch (err) {
      localStorage.removeItem("user");
      localStorage.removeItem("isAuthenticated");
      return null;
    }
  });

  const [grnRecords, setGrnRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    localStorage.setItem('isAuthenticated', isAuthenticated);
    if (!isAuthenticated) {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      setUser(null);
      setGrnRecords([]);
    }
  }, [isAuthenticated]);

  const login = async (email, password) => {
    try {
      const response = await axios.post(`${API_URL}/auth/login`, {
        email,
        password,
      });

      if (response.data.success) {
        const userData = {
          email: response.data.user.email,
          name: response.data.user.name,
          role: response.data.user.role,
        };

        if (!userData.email || !userData.name) {
          throw new Error("Invalid user data received from server");
        }
        setIsAuthenticated(true);
        setUser(userData);
        localStorage.setItem("user", JSON.stringify(userData));
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("isAuthenticated", "true");
        console.log("Stored user:", userData, "isAuthenticated:", true);
        return { 
          success: true,
          user: userData
        };
      } else {
        throw new Error(response.data.message || "Login failed");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to login");
      setIsAuthenticated(false);
      setUser(null);
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      localStorage.removeItem("isAuthenticated");
      return { success: false, message: err.message };
    }
  };

  const logout = () => {
    setIsAuthenticated(false);
    setUser(null);
    setGrnRecords([]);
    setError(null);
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("user");
    localStorage.removeItem("token");
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      const decoded = JSON.parse(atob(token.split(".")[1]));
      const now = Date.now() / 1000;

      if (decoded.exp < now) {
        logout();
        return;
      }

      const timeLeft = (decoded.exp - now) * 1000;

      const timer = setTimeout(() => {
        logout();
      }, timeLeft);

      return () => clearTimeout(timer);
    } catch (error) {
      console.error("Failed to decode token", error);
      logout();
    }
  }, [isAuthenticated]);



  return (
    <GRNContext.Provider 
      value={{ 
        isAuthenticated, 
        user,
        login, 
        logout, 
        grnRecords, 
        setGrnRecords,
        loading, 
        error 
      }}
    >
      {children}
    </GRNContext.Provider>
  );
};